export const ClipPath = (function () {
	'use strict';

	let $clippath,
			$maskTemplate,
			$pxblock,
			$svgClipPath,
			curveData,
			isIOS,
			isSafari;

	function init() {
		$clippath = $('.clippath');
		$maskTemplate = $('#maskTemplate');
		$pxblock = $('.pxblock');
		$svgClipPath = $('#svgClipPath');
		curveData = "M0,0 C0,0 h,c w,0 Lw,0 Lw,20000 L0,20000 Z";
		isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		isSafari = navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") < 0;

		updateClipPath(true);
		$(window).on('load', updateClipPath);
		$(window).on('resize', updateClipPath);
	}

	function updateClipPath(firstLoad) {
		let width = $(window).width();
		let halfWidth = Math.round(width / 2, 2);
		let curveDepth = Math.round(width * 0.042, 2);
		let d = curveData;

		d = d.replace(/w/g, width);
		d = d.replace(/h/g, halfWidth);
		d = d.replace(/c/g, curveDepth);

		$svgClipPath.find('path').attr('d', d);

		if (firstLoad && (isIOS || isSafari) ) {
			$('.pxblock').css({
				'clip-path': 'none'
			});

			setTimeout(function(){
				$('.pxblock').css({
					'clip-path': 'url(#svgClipPath)'
				});
			}, 1);
		}
	}

	return {
		init: init,
	};
})();
